import React from 'react';
import '../../styles/Modal.css';

const DeleteModal = ({ isActive, onClose, onConfirm, itemName }) => {
    return (
        <div className={`modal ${isActive ? 'is-active' : ''}`}>
            <div className="modal-background" onClick={onClose}></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title">Confirmation de suppression</p>
                    <button className="delete" aria-label="close" onClick={onClose}></button>
                </header>
                <section className="modal-card-body">
                    <p>Êtes-vous sûr de vouloir supprimer les données de "{itemName}" ?</p>
                </section>
                <footer className="modal-card-foot">
                    <button className="button" onClick={onClose}>Annuler</button>
                    <button className="button is-danger" onClick={onConfirm}>Supprimer</button>
                </footer>
            </div>
        </div>
    );
};

export default DeleteModal;
